const pad = (n) => String(n).padStart(2, '0');

// format: 'dmy' -> 23.11.2026, 'mdy' -> 11.23.2026, 'long' -> November 23, 2026
const formatDate = (date, format = 'dmy') => {
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) return '';

  if (format === 'long') {
    return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  }

  const day = pad(d.getDate());
  const month = pad(d.getMonth() + 1);
  const year = d.getFullYear();

  return format === 'mdy' ? `${month}.${day}.${year}` : `${day}.${month}.${year}`;
};

export default formatDate;
